import { generateUUIDv4 } from '@/utils/number';

export const PRE_CLAIMS_TYPES_OPTIONS = [
  { label: 'In-House', value: 'I' },
  { label: 'Claim', value: 'E' },
];

export const PRE_CLAIMS_CREATE_DEFAULT_VALUES = {
  FILES: [
    {
      claimKey: 0,
      description: undefined,
      documentType: undefined,
      editMode: true,
      fileComments: undefined,
      fileDesc: undefined,
      fileList: [],
      fileName: undefined,
      id: generateUUIDv4(),
      isInitial: true,
      isNew: true,
      originalFileName: undefined,
      sequence: 1,
    },
  ],
  ITEMS: [
    {
      claimKey: 0,
      dirtyFlag: 'i',
      dispositionMethod: '',
      editMode: true,
      fullRelFlag: '',
      isInitial: true,
      isNew: true,
      itemCode: '',
      itemDesc: '',
      itemQuantity: undefined,
      itemSeq: 1,
      itemUnitMeasure: '',
      measure: '',
      smAmount: undefined,
      smFlag: '',
      smType: '',
      value: undefined,
    },
  ],
  NOTES: [
    {
      commentText: undefined,
      commentType: undefined,
      dirtyFlag: 'i',
      editMode: true,
      id: undefined,
      isInitial: true,
      isNew: true,
      oldCommentType: null,
      sequenceNo: 1,
    },
  ],
};
